import PropTypes from "prop-types";
import SortIcons from "./SortIcons";

/**
 * A sortable table column header button.
 * Renders a `<button>` with the column label and sort direction indicators.
 *
 * Usage:
 *   <SortHeader
 *     label="Last Name"
 *     columnKey="lastName"
 *     sortConfig={sortConfig}
 *     onSort={requestSort}
 *   />
 *
 * @param {string}   props.label      - visible column label
 * @param {string}   props.columnKey  - the key passed to onSort
 * @param {{key: string, direction: string}} props.sortConfig
 * @param {Function} props.onSort     - called with columnKey when clicked
 * @param {string}   [props.className]
 */
const SortHeader = ({ label, columnKey, sortConfig, onSort, className }) => (
    <button
        type="button"
        className={className || "table-header-button"}
        aria-label={`Sort by ${label}`}
        onClick={() => onSort(columnKey)}
    >
        {label} <SortIcons active={sortConfig.key === columnKey} direction={sortConfig.direction} />
    </button>
);

SortHeader.propTypes = {
    label: PropTypes.string.isRequired,
    columnKey: PropTypes.string.isRequired,
    sortConfig: PropTypes.shape({
        key: PropTypes.string,
        direction: PropTypes.oneOf(["ascending", "descending"])
    }).isRequired,
    onSort: PropTypes.func.isRequired,
    className: PropTypes.string
};

export default SortHeader;
